module.exports = __webpack_public_path__ + "media/printed-materials/educators-06-college-qrg-26eaf3d9.png";